import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  Button,
} from "@mui/material";
import EastIcon from "@mui/icons-material/Add";
import { validateNumberInput, validatePercentageDecimalInput } from "../../../utils/validateFields";
import UploadFileBrsr from "../../Common/UploadFileBrsr";
import FetchFilesBrsr from "../../Common/FetchFilesBrsr";

function EmpTable({
  columnWidth,
  heading,
  columnValue,
  title,
  topHeading,
  topheader,
  formValues,
  setErrors,
  errorsindex,
  setFormValues,
  setIndex,
  errors,
  disabled,
  percentValue = false,
}) {
  const [fileUrls, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [columnArray, setColumnArray] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalupload, setModalUpload] = useState(false);
  const handleUploadDocument = () => {
    setModalUpload(true);
    setOpen(true);
  };
  useEffect(() => {
    const columnLength = columnWidth.split(" ");
    setColumnArray(columnLength);
  }, [columnWidth]);

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const handleChangeRadio = ({ target: { name, value } }) => {
    setFormValues((prev) => {
      const keys = name.split("."); // Assuming `name` is a dot-separated string
      const updatedForm = { ...prev };

      let current = updatedForm;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value; // Update the specific field
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return updatedForm;
    });
  };

  useEffect(() => {
    let newErrors = {};

    columnValue.forEach((item, rowIndex) => {
      if (item.value) {
        heading.slice(1).forEach((headings) => {
          const name = `${item.key}.${headings.key}`;
          newErrors[name] = {
            rowIndex,
            message: "", // Initialize with empty error message
          };
        });
      }
    });

    // Preserve previous errors instead of overriding them

    if (setIndex) {
      setIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const isValidInput = percentValue
      ? validatePercentageDecimalInput(value)
      : validateNumberInput(value);
    if (!isValidInput) return;

    setFormValues((prevState) => {
      if (!prevState) return {};
      const keys = name.split(".");
      const updatedData = structuredClone(prevState);

      let currentLevel = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }

      const field = keys[keys.length - 1];
      currentLevel[field] = percentValue
        ? value
        : value
          ? Number(value)
          : 0;

      const parentObject = keys
        .slice(0, -1)
        .reduce((obj, key) => obj?.[key], updatedData);

      // Handle female percentage calculation in womenRepresentation
      if (keys[0] === "womenRepresentation") {
        const boardOfDirectorsDatas = parentObject?.boardOfDirectors?.total;
        const keyManagementPersonnelTotal =
          parentObject?.keyManagementPersonnel?.total;
        const femaleboard = parentObject?.boardOfDirectors?.female;
        const femaleKey = parentObject?.boardOfDirectors?.female;
        parentObject.femalepercentage =
          (femaleboard / boardOfDirectorsDatas) * 100;
        parentObject.femalepercentage =
          (femaleKey / keyManagementPersonnelTotal) * 100;
      }

      const total = currentLevel?.total || 0;
      const male = currentLevel?.male || 0;
      const female = currentLevel?.female || 0;

      const sumGender = Number(male) + Number(female);

      // Error if male + female exceeds total and user is editing male/female
      if (["male", "female"].includes(field) && sumGender > total) {
        if (errorsindex) {
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            const mainKey = keys[0];
            const lastKey = keys[keys.length - 1];
            const subKey = keys.length > 3 ? `${keys[1]}.${keys[2]}` : keys[1];
            const rowIndex =
              errorsindex[
                keys.length > 3
                  ? `${keys[0]}.${keys[1]}.${keys[2]}.${keys[3]}`
                  : `${keys[0]}.${keys[1]}.${keys[2]}`
              ]?.rowIndex || "-";

            newErrors[mainKey] = [
              {
                subkey: subKey,
                fieldName: lastKey,
                rowIndex: rowIndex,
                message: "Exceeded the value required field",
              },
            ];
            return newErrors;
          });
          return prevState;
        }
      } else {
        setErrors([]);
      }

      // Gender-based percentage calculations
      if ("malepercentage" in currentLevel) {
        currentLevel.malepercentage =
          total > 0 ? ((male / total) * 100).toFixed(2) : 0;
      }

      if ("femalepercentage" in currentLevel) {
        currentLevel.femalepercentage =
          total > 0 ? ((female / total) * 100).toFixed(2) : 0;

        if (female > total && keys[0] === "womenRepresentation") {
          // setErrors((prevErrors) => {
          //   const newErrors = { ...prevErrors };
          //   const mainKey = keys[0];
          //   const lastKey = keys[keys.length - 1];
          //   const subKey = keys.length > 3 ? `${keys[1]}.${keys[2]}` : keys[1];
          //   const rowIndex =
          //     errorsindex[
          //       keys.length > 3
          //         ? `${keys[0]}.${keys[1]}.${keys[2]}.${keys[3]}`
          //         : `${keys[0]}.${keys[1]}.${keys[2]}`
          //     ]?.rowIndex || "-";
          //   newErrors[mainKey] = [
          //     {
          //       subkey: subKey,
          //       fieldName: lastKey,
          //       rowIndex: rowIndex,
          //       message: "Exceeded the value required field",
          //     },
          //   ];
          //   return newErrors;
          // });
          // return prevState;
        }
      }

      // Auto-calculate total only when male or female is edited
      const editedField = keys[keys.length - 1];
      if (
        editedField === "male" ||
        editedField === "female" ||
        editedField === "total"
      ) {
        if (editedField === "total" && prevState) {
          currentLevel.male = 0;
          currentLevel.female = 0;

          // Reset male/female percentages too
          if ("malepercentage" in currentLevel) currentLevel.malepercentage = 0;
          if ("femalepercentage" in currentLevel)
            currentLevel.femalepercentage = 0;
        }
        let tempData = updatedData;
        for (let i = 0; i < keys.length - 1; i++) {
          tempData = tempData[keys[i]];
        }
        if ("total" in tempData) {
          // updatedData[keys[0]].total = calculateTotals(updatedData[keys[0]]);
          const mainKey = keys.length > 3 ? `${keys[0]}.${keys[1]}` : keys[0];

          let lastPreviousKeys = [];
          let tempData = updatedData;
          for (let i = 0; i < keys.length - 1; i++) {
            if (tempData?.[keys[i]]) {
              if (keys.length === 3) {
                // If only 3 keys, store the first key
                lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
              } else if (keys.length >= 4) {
                // If 4 or more keys, store the second key and last-to-previous key
                lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
              }

              tempData = tempData[keys[i]]; // Move deeper
            } else {
              break;
            }
          }
          if (keys.length > 3) {
            const [firstKey, secondKey] = keys;
            if (
              updatedData[firstKey]?.[secondKey] &&
              lastPreviousKeys[1].includes("total")
            ) {
              updatedData[firstKey][secondKey].total = calculateTotals(
                updatedData[firstKey][secondKey],
              );
            }
          } else {
            if (updatedData[mainKey] && lastPreviousKeys[0].includes("total")) {
              updatedData[mainKey].total = calculateTotals(
                updatedData[mainKey],
              );
            }
          }
        }
      }

      return updatedData;
    });
  };
  const handleChangeTurnOver = (e) => {
    const { name, value } = e.target;

    const isValidInput = percentValue
      ? validatePercentageDecimalInput(value)
      : validateNumberInput(value);
    if (!isValidInput) return;

    setFormValues((prevState) => {
      if (!prevState) return {};

      const keys = name.split(".");
      const updatedData = structuredClone(prevState);

      let currentLevel = updatedData.turnoverRate;
      for (let i = 1; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }

      const field = keys[keys.length - 1];
      currentLevel[field] = percentValue
        ? value
        : value
          ? Number(value)
          : 0;

      const total = Number(currentLevel.total) || 0;
      const male = Number(currentLevel.male) || 0;
      const female = Number(currentLevel.female) || 0;
      const sumGender = male + female;

      // Auto-calculate total
      if (field === "male" || field === "female") {
        currentLevel.total = sumGender;
      }

      // Reset male/female if total is manually changed
      if (field === "total") {
        currentLevel.male = 0;
        currentLevel.female = 0;
      }

      // ✅ Return updated full object
      return {
        ...prevState,
        turnoverRate: updatedData.turnoverRate,
      };
    });
  };

  const calculateTotals = (data) => {
    const totalEmployees = ["permanent", "other"].reduce(
      (acc, key) => {
        const category = data[key];
        acc.total += Number(category.total || 0);
        acc.male += Number(category.male || 0);
        acc.female += Number(category.female || 0);
        return acc;
      },
      { total: 0, male: 0, female: 0 },
    );

    return {
      total: totalEmployees.total,
      male: totalEmployees.male,
      female: totalEmployees.female,
      malepercentage: totalEmployees.total
        ? ((totalEmployees.male / totalEmployees.total) * 100).toFixed(2)
        : 0,
      femalepercentage: totalEmployees.total
        ? ((totalEmployees.female / totalEmployees.total) * 100).toFixed(2)
        : 0,
    };
  };
  return (
    <Box sx={{ minWidth: 650 }}>
      <Typography
        sx={{ marginBottom: "20px", fontWeight: "bold", marginTop: "10px" }}
        variant="body1"
        gutterBottom
      >
        {topheader}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        {topHeading}
      </Typography>
      <Typography
        sx={{
          marginBottom: "20px",
          fontWeight: "bold",
          marginTop: "10px",
          marginLeft: "15px",
        }}
        variant="body1"
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer component={Paper} sx={{ maxWidth: "98%", ml: "17px" }}>
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {columnValue.map((item, rowIndex) => {
            if (item.value) {
              const isTotalRow = item.value.includes("Total"); // Check if the row is a Total row

              return (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: columnWidth,
                    borderBottom: "1px solid #ddd",
                    justifyContent: "center",
                  }}
                >
                  {/* Render Typography for the row */}
                  <Typography
                    sx={{
                      borderRight: "1px solid #DBDBDB",
                      fontSize: "15px",
                      padding: "10px",
                    }}
                  >
                    {item.value}
                  </Typography>
                  {heading.length > 0 &&
                    heading.slice(1).map((headings, index) => {
                      const differentlyAbled = item.key
                        ?.toLowerCase()
                        .includes("differentlyabled");
                      const turnoverRate = item.key?.includes("turnoverRate");
                      const wellBeingMeasures =
                        item.key?.includes("wellBeingMeasures");
                      const wellBeingWorkers =
                        item.key?.includes("wellBeingWorkers");
                      const retirementBenefits =
                        item.key?.includes("retirementBenefits");
                      const returnAndRetentionParentalLeave =
                        item.key?.includes("returnAndRetentionParentalLeave");
                      const performanceAndCareerReviews = item.key?.includes(
                        "performanceAndCareerReviews",
                      );
                      const name = `${item.key}.${headings.key}`;

                      // Split the name into parts using '.' as a delimiter
                      const matchResult = name.split(".");

                      // Ensure the split result is valid
                      if (matchResult.length < 3) {
                        // console.error(`Invalid name format: ${name}`);
                        return null; // Skip this iteration if the name format is invalid
                      }

                      const [
                        mainKey,
                        subKey,
                        fieldKey,
                        differentlyAbledKey,
                        retirementBenefitsKey,
                      ] = matchResult;

                      const isPercentage =
                        headings.key !== "employeesCovered" &&
                        headings.key !== "workersCovered" &&
                        headings.title.includes("%");
                      // const isTotal = headings.title.includes("Total" !=="Total Employees");
                      const isTotal =
                        /Total(?! Employees || ?! No. of Employees)/.test(
                          headings.title,
                        );
                      const isTotalTurnOver =
                        mainKey === "turnoverRate" && headings.key === "total";
                      console.log(
                        mainKey === "turnoverRate" ? headings.title : null,
                        "mainKey === turnoverRate",
                      );
                      return (
                        <>
                          {/* {console.log(
                            name,
                            retirementBenefitsKey,
                            retirementBenefitsKey === "deductedDeposited" &&
                              formValues?.[mainKey]?.[subKey]?.[fieldKey]
                                ?.deductedDeposited,
                            "percentage++++"
                          )} */}
                          <TextField
                            key={index} // Adding a key for mapping
                            variant="standard"
                            disabled={
                              isTotal || isTotalTurnOver
                                ? true
                                : isPercentage && !percentValue
                                  ? true
                                  : isTotalRow
                                    ? true
                                    : false || disabled
                            }
                            sx={{
                              backgroundColor:
                                (isPercentage && !percentValue) ||
                                isTotal ||
                                isTotalRow ||
                                isTotalTurnOver
                                  ? "#EFEFEF"
                                  : "",
                              borderRight: "1px solid #DBDBDB",
                              padding: "8px 12px",
                              "& .MuiInputBase-root": {
                                padding: 0, // Align with grid cells
                              },
                            }}
                            name={name}
                            type="text"
                            InputProps={{ disableUnderline: true }}
                            fullWidth
                            size="small"
                            value={
                              differentlyAbled ||
                              turnoverRate ||
                              wellBeingMeasures ||
                              wellBeingWorkers ||
                              returnAndRetentionParentalLeave ||
                              performanceAndCareerReviews
                                ? (formValues?.[mainKey]?.[
                                    mainKey === "wellBeingMeasures" ||
                                    mainKey === "wellBeingWorkers" ||
                                    mainKey === "retirementBenefits" ||
                                    mainKey ===
                                      "returnAndRetentionParentalLeave" ||
                                    mainKey === "turnoverRate"
                                      ? subKey
                                      : subKey.toLowerCase()
                                  ]?.[
                                    mainKey === "wellBeingMeasures" ||
                                    mainKey === "wellBeingWorkers" ||
                                    mainKey === "retirementBenefits" ||
                                    mainKey ===
                                      "returnAndRetentionParentalLeave" ||
                                    mainKey === "turnoverRate"
                                      ? fieldKey
                                      : fieldKey?.toLowerCase()
                                  ]?.[
                                    mainKey === "wellBeingMeasures" ||
                                    mainKey === "wellBeingWorkers" ||
                                    mainKey === "retirementBenefits" ||
                                    mainKey ===
                                      "returnAndRetentionParentalLeave" ||
                                    mainKey === "performanceAndCareerReviews" ||
                                    mainKey === "turnoverRate"
                                      ? differentlyAbledKey
                                      : differentlyAbledKey?.toLowerCase()
                                  ] ?? "")
                                : retirementBenefits
                                  ? (formValues?.[mainKey]?.[
                                      mainKey === "wellBeingMeasures" ||
                                      mainKey === "wellBeingWorkers" ||
                                      mainKey === "retirementBenefits" ||
                                      mainKey === "performanceAndCareerReviews"
                                        ? subKey
                                        : subKey.toLowerCase()
                                    ]?.[
                                      mainKey === "wellBeingMeasures" ||
                                      mainKey === "wellBeingWorkers" ||
                                      mainKey === "retirementBenefits" ||
                                      mainKey === "performanceAndCareerReviews"
                                        ? fieldKey
                                        : fieldKey?.toLowerCase()
                                    ]?.[
                                      mainKey === "wellBeingMeasures" ||
                                      mainKey === "wellBeingWorkers" ||
                                      mainKey === "retirementBenefits" ||
                                      mainKey === "performanceAndCareerReviews"
                                        ? differentlyAbledKey
                                        : differentlyAbledKey?.toLowerCase()
                                    ]?.[
                                      mainKey === "retirementBenefits" ||
                                        (mainKey ===
                                          "performanceAndCareerReviews" &&
                                          retirementBenefitsKey)
                                    ] ?? "")
                                  : (formValues?.[mainKey]?.[
                                      mainKey === "womenRepresentation"
                                        ? subKey
                                        : subKey.toLowerCase()
                                    ]?.[fieldKey?.toLowerCase()] ?? "")
                            }
                            placeholder={
                              isTotal
                                ? "Total"
                                : isPercentage
                                ? "%"
                                : "Enter Number"
                            }
                            onChange={
                              mainKey === "turnoverRate"
                                ? (e) => handleChangeTurnOver(e, rowIndex)
                                : !isTotalRow
                                  ? (e) => handleChange(e, rowIndex)
                                  : undefined
                            }
                          />
                        </>
                      );
                    })}
                </Box>
              );
            }
          })}
        </Box>
      </TableContainer>
      {/* <Box  sx={{ mt: 1}}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
               onClick={handleUploadDocument}
              >
                Upload Document <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
         { modalupload === true ? <UploadFileBrsr
        {...{
          // handleChange,
          // handleDelete,
          setModalUpload,
          setUploadProgress,
          setUploadedFiles,
          setErrors,
          errors,
          fileUrls,
          progress,
          open,
          setOpen,

          // subText,
        }}
      />
    : modalupload ==="file"? <FetchFilesBrsr 
    {...{fileUrls}}
    />
   :null } */}
      {errors
        ? Object.entries(
            errors.reduce((acc, item) => {
              if (!acc[item.rowIndex]) {
                acc[item.rowIndex] = [];
              }
              acc[item.rowIndex].push(item.fieldName);
              return acc;
            }, {}),
          ).map(([rowIndex, fields], idx) => (
            <Typography
              variant="body2"
              color="error"
              key={`error-${rowIndex}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "0px",
              }}
            >
              Row {rowIndex} Missing fields: - {fields.join(", ")}
            </Typography>
          ))
        : null}
    </Box>
  );
}

export default EmpTable;
